const action = "BLUEPRINTS_PUBLIC_LIST";
export const FETCH_REQUEST = action + '_FETCH_REQUEST';
export const FETCH_SUCCESS = action + '_FETCH_SUCCESS';
export const FETCH_ERROR = action + '_FETCH_ERROR';

export const fetchRequest = (filters = {}) => ({
  type: FETCH_REQUEST,
  payload: { filters }
});

export const fetchSuccess = (response) => ({
  type: FETCH_SUCCESS,
  payload: { response }
});

export const fetchError = (error) => ({
  type: FETCH_ERROR,
  payload: { error }
}); 